module.exports = new __parcel__URL__("ExclamationWarning.60df26b1.svg").toString();